<template>
  <v-app>
    <core-app-bar />

    <aurora-drawer
      :background="require(`./images/drawer-background.jpg`)"
      :anonymous-menu="anonymousMenu"
      :authenticated-menu="authenticatedMenu"
      class="hidden-print-only"
    >
      <template v-slot:title>
        <v-img
          circle
          src="./images/logo.png"
          height="34"
          contain
        />
        {{ $t('Common.appTitle') }}
      </template>
    </aurora-drawer>


    <aurora-network-progress-bar id="top-aurora-network-progress-bar" />
    <core-view id="main-core-view" />

    <core-footer />
    <aurora-service />
    <aurora-dialog-confirm ref="confirm" id="aurora-dialog-confirm"></aurora-dialog-confirm>
    <aurora-auth />
  </v-app>
</template>

<script>
import { anonymousMenu, authenticatedMenu } from './navigation';

export default {
  components: {
    CoreFooter: () => import('@/components/core/Footer'),
    CoreAppBar: () => import('@/components/core/AppBar'),
    CoreView: () => import('@/components/core/View'),
  },
  data() {
    return {
      anonymousMenu,
      authenticatedMenu,
    };
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$auroraHub.$on('user.loggedIn', () => {
      this.$router.push({ path: 'Dashboard' });
    });
  },
};
</script>
<style>
@media print {
  #main-core-view {
    padding: 0 !important;
  }
}
</style>
